export const themeColors = {
    black_100: "#F6F7FB",
    black_200: "#ECEDF1",
    black_300: "#DADEE5",
    black_400: "#B5BAC6",
    black_500: "#798194",
    black_600: "#363C49",
    black_700: "#000B23",
    blue: "#58A5ED",
    blueSolid: "#D7E9FB",
    green: "#89F09F",
    greenSolid: "#E3FBE8",
    green_700: "#47C799",
    lavender: "#CEC6FF",
    pink: "#F6C5D8",
    pinkSolid: "#FDF1F6",
    purpleLight: "#89A0F0",
    purpleLightSolid: "#E3E8FB",
    purpleMedium: "#5879ED",
    red_200: "#FFDCDC",
    red_700: "#FF4E4E",
    yellow: "#FFCC67",
    yellowSolid: "#FFF3DB",
    qalmoBlue: "#000B23",
  };